import { render, staticRenderFns } from "./ResidentTypeForm.vue?vue&type=template&id=01802e07&scoped=true&"
import script from "./ResidentTypeForm.vue?vue&type=script&lang=js&"
export * from "./ResidentTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./ResidentTypeForm.vue?vue&type=style&index=0&id=01802e07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01802e07",
  null
  
)

export default component.exports